import { Alert } from '@mui/material';

type UnknownEntityPanelProps = {
  entityType: string;
};

export default function UnknownEntityPanel({ entityType }: UnknownEntityPanelProps) {
  return (
    <Alert severity="info" sx={{ borderRadius: 2 }}>
      No renderer is available yet for entity type: {entityType || '(unknown)'}.
    </Alert>
  );
}

